export enum SegmentationState {
  /**
   * The segmentation is idle and ready for interaction
   */
  IDLE = 'IDLE',

  /**
   * The segmentation is disabled or out of service
   */
  DISABLED = 'DISABLED',

  /**
   * Points or bounding boxes are being added
   */
  ADDING = 'ADDING',

  /**
   * Points or bounding boxes are being edited
   */
  EDITING = 'EDITING',

  /**
   * Points or bounding boxes are being removed
   */
  REMOVING = 'REMOVING',

  /**
   * Labels are being added or edited for polygons
   */
  LABELING = 'LABELING',

  /**
   * The segmentation is being processed on the server
   */
  PROCESSING = 'PROCESSING',

  /**
   * The segmentation result is being displayed
   */
  DISPLAYING_RESULT = 'DISPLAYING_RESULT',

  /**
   * The segmentation is being loaded or initialized
   */
  LOADING = 'LOADING',

  /**
   * An error has occurred during an operation
   */
  ERROR = 'ERROR',
}

export default SegmentationState;
